<!-- <div class="maintenance-overlay">
  <div class="maintenance-box">
    <h3>Notice:</h3>
    <p>
The portal is temporarily unavailable due to scheduled maintenance. Services will resume shortly. We regret the inconvenience and thank you for your cooperation.</p>
  </div>
</div> -->
<router-outlet *ngIf="cssLoaded"></router-outlet>
<div class="loader-container">
    <app-loader [@fadeInOut]="loaderService.showLoader$ | async">{{loaderService.getTitle()}}</app-loader>
</div>
<app-toast></app-toast>
<app-chatbot></app-chatbot>
